import NewsListPage from './NewsListPage';

export default NewsListPage;
